var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.onLine)?_c('div',[(
        ['/terms-condition'].indexOf(_vm.$route.path) < 0 &&
          ['/help-page'].indexOf(_vm.$route.path) < 0 &&
          ['/terms-condition-ticket'].indexOf(_vm.$route.path) < 0 &&
          ['/how-it-works'].indexOf(_vm.$route.path) < 0
      )?_c('Header'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(
        ['/terms-condition'].indexOf(_vm.$route.path) < 0 &&
          ['/help-page'].indexOf(_vm.$route.path) < 0 &&
          ['/terms-condition-ticket'].indexOf(_vm.$route.path) < 0 &&
          ['/how-it-works'].indexOf(_vm.$route.path) < 0
      )?_c('Footer'):_vm._e()],1):_c('div',[_c('connectionLost')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55290278","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1113
// module chunks = 1